import { OfferItemSlider } from "../Model/OfferItemSlider";
import { OffersPromoRepository } from "../Repository/OffersPromoRepository";


export interface GetOfferItemSliderByIdUseCase {
  invoke: (id: number) => Promise<OfferItemSlider | null>;
}

export class GetOfferItemSliderById implements GetOfferItemSliderByIdUseCase {
  private Repo: OffersPromoRepository;
  constructor(_Repo: OffersPromoRepository) {
    this.Repo = _Repo;
  }

   invoke(id: number){
    if(!id){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
    const getData = this.Repo.getOfferItemSliderById(id);
    return getData;
  }
}